




















































































































































import Vue from 'vue';
import { UserModel } from '@/types';
import { UserService } from '@/services/UserService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import MStorePickList from '@/components/shared/MStorePickList.vue';
import { StandardRole } from '@/types/enums';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ViewUser',
  data() {
    return {
      user: {} as UserModel,
      isLoading: true,
      hasError: false,
      errorMessage: '',
      sendEmailIsLoading: false,
      picklistFields: [
        {
          key: 'name',
          label: 'Role Name',
          sortable: true
        },
        {
          key: 'description',
          label: 'Role Description',
          sortable: true
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      fixedItems: [StandardRole.Everyone]
    };
  },
  methods: {
    async getUserAsync(id: number) {
      UserService.getUserAsync(id)
        .then((result: any) => {
          this.user = result;
          this.fixedItems.push(this.user.defaultRoleId);
          this.isLoading = false;
        })
        .catch((error: any) => {
          this.isLoading = false;
          this.hasError = true;
          this.errorMessage = error.notification;
        });
    },
    async removeAccessLockAsync(this: any) {
      await UserService.removeAccessLockAsync(this.user.id).then((response) => {
        SnotifyConfiguration.showSuccess('User unlocked successfully.');
        this.user.isLockedOut = false;
      });
    },
    navigate(routeName: any) {
      this.$router.push({ name: routeName });
    },
    async sendUserEmailAsync(methodName: any) {
      this.sendEmailIsLoading = true;
      UserService.sendUserEmailAsync(this.user.id, methodName)
        .then((response) => {
          this.$bvModal.msgBoxOk('Email sent successfully', {
            okVariant: 'success',
            noCloseOnBackdrop: true
          });
          this.sendEmailIsLoading = false;
        })
        .catch((error: any) => {
          SnotifyConfiguration.showError(error.notification);
          this.sendEmailIsLoading = false;
        });
    },
    saveRoles(newroles: any) {
      UserService.updateUserRolesAsync({
        user: this.user,
        roles: newroles
      }).then((result: any) => {
        SnotifyConfiguration.showSuccess('User roles updated successfully.');
      });
    }
  },
  mounted(this: any) {
    this.isLoading = true;
    this.getUserAsync(this.$route.params.id);
  },
  computed: {
    userIsActive: {
      get(this: any) {
        return !this.user.isDeactivated;
      },
      set(this: any, value: boolean) {
        this.user.isDeactivated = !value;
      }
    },
    ShowSendWelcomeEmailButton(this: any) {
      return this.userIsActive && this.user.hasTemporaryPassword;
    },
    ShowPasswordResetLinkButton(this: any) {
      return this.userIsActive && !this.user.hasTemporaryPassword;
    }
  },
  components: {
    MStorePickList,
    LoadingSpinner
  }
});
